module.exports = function() {
  return new Worker(__webpack_public_path__ + "818e36336254b6e7712f.worker.js");
};